module.exports = __webpack_public_path__ + "static/media/grafismo-projects.2570d2cc.svg";